import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { LicenseServerErrorCode, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { HostLicenseService, ModalService, TenantService, } from '@services';
import UiValidators from '@validators';
import { merge, of, Subject, } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, tap, } from 'rxjs/operators';
var emptySuggestData$ = of({
    id: 0,
    text: '...',
    data: null,
});
var TenantLicenseModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TenantLicenseModalComponent, _super);
    function TenantLicenseModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isSelfLicensed = false;
        _this.noTenants = false;
        _this._tenantSource = new Subject();
        _this._fb = _this._injector.get(FormBuilder);
        _this._hostLicenseService = _this._injector.get(HostLicenseService);
        _this._tenantService = _this._injector.get(TenantService);
        _this._modalService = _this._injector.get(ModalService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this.tenantSourceFactory = function (searchTerm, pageSize, skip) {
            if (skip === void 0) { skip = 0; }
            return _this._tenantService
                .get({
                orderBy: ['Name'],
                top: pageSize,
                skip: skip,
                filter: {
                    Name: {
                        contains: searchTerm,
                    },
                    IsActive: {
                        eq: true,
                    },
                },
            })
                .pipe(tap(function (response) {
                var newState = !searchTerm.trim() &&
                    !response.total;
                if (newState !== _this.noTenants) {
                    _this.noTenants = newState;
                    _this._cd.detectChanges();
                }
            }), map(function (response) { return ({
                total: response.total,
                data: response
                    .data
                    .map(_this._mapTenant),
            }); }));
        };
        _this.shouldChangeTenant = function (tenant) {
            var isTenantSet = tenant != null &&
                !!tenant.id;
            return !isTenantSet;
        };
        _this.changeTenant = function (entry) {
            if (!!entry.data) {
                _this._tenantSource.next(entry.data.id);
            }
        };
        _this._updateFormValues = function (tenantLicense) {
            Object
                .keys(tenantLicense.allowed)
                .forEach(function (keyStr) {
                var key = keyStr;
                _this.formGroup.get(key).patchValue(tenantLicense.allowed[key]);
            });
        };
        _this._updateTenantLicense = function (tenant) {
            if (!tenant.id) {
                return of();
            }
            return _this.tenantLicense$ = _this._hostLicenseService
                .getLicenseForTenant(Number(tenant.id))
                .pipe(tap(function (tenantLicense) {
                _this.isSelfLicensed = tenantLicense.isRegistered &&
                    tenantLicense.hostLicenseId == null;
            }), tap(function () { return _this._updateReadState(); }), tap(function (tenantLicense) { return _this._updateFormValidators(tenantLicense); }), tap(_this._updateFormValues));
        };
        _this._switchToTenant = function (id) {
            if (!!id) {
                return _this._tenantService
                    .getInstance(id)
                    .pipe(map(_this._mapTenant));
            }
            return emptySuggestData$;
        };
        _this._mapTenant = function (tenant) { return ({
            id: tenant.id,
            text: tenant.name,
            data: tenant,
        }); };
        return _this;
    }
    TenantLicenseModalComponent.prototype.ngOnInit = function () {
        this.tenantFormGroup = this._fb.group({
            'tenant': [],
        });
        this.formGroup = this._fb.group({
            'attended': [],
            'unattended': [],
            'nonProduction': [],
            'development': [],
            'studioX': [],
        }, {
            validator: function (form) {
                var sum = 0;
                Object
                    .keys(form.controls)
                    .forEach(function (key) {
                    return sum += +form.get(key).value;
                });
                return !!sum ? null : {
                    noLicense: true,
                };
            },
        });
        this.tenant$ =
            merge(of(this.context.data.id), this._tenantSource)
                .pipe(map(function (id) { return Number(id); }), distinctUntilChanged(), switchMap(this._switchToTenant), tap(this._updateTenantLicense));
        this.license$ = this._appState.user.license.value$;
        this._appState.user.license.fetch();
    };
    TenantLicenseModalComponent.prototype.setLicense = function (hostLicenseId, tenantId, licenseConfiguration) {
        var _this = this;
        var event = {
            type: 2 /* Update */,
        };
        licenseConfiguration.hostLicenseId = hostLicenseId;
        licenseConfiguration.tenantId = tenantId;
        Object
            .keys(licenseConfiguration)
            .forEach(function (keyStr) {
            var key = keyStr;
            licenseConfiguration[key] = +licenseConfiguration[key];
        });
        this._hostLicenseService
            .setLicenseForTenant(licenseConfiguration)
            .pipe(tap(function () {
            if (_this.context.additionalData.closeAfterAllocation) {
                _this._dialogRef.close(event);
            }
        }), switchMap(function () { return _this._appState.user.license.fetch(); }), filter(function () { return !_this.context.additionalData.closeAfterAllocation; }), switchMap(function () { return _this._updateTenantLicense({
            id: tenantId,
        }); }), tap(function () { return _this._cd.detectChanges(); }), tap(function () { return _this.customEvent.emit(event); }))
            .subscribe();
    };
    TenantLicenseModalComponent.prototype.removeLicense = function (tenantId) {
        var _this = this;
        var initial$ = this.isSelfLicensed ?
            this._appState.user.license.deactivateLicenseOnline(tenantId) :
            of(0);
        this._modalService.onConfirm(null, function () {
            initial$
                .pipe(switchMap(function () { return _this._hostLicenseService
                .deleteLicenseForTenant(tenantId); }), switchMap(function () { return _this._appState.user.license.fetch(); }), switchMap(function () { return _this._updateTenantLicense({
                id: tenantId,
            }); }))
                .subscribe(function () {
                _this._cd.detectChanges();
                _this.customEvent.emit({
                    type: 2 /* Update */,
                });
            }, function (error) {
                if (error.status === 503
                    && error.error.errorCode === LicenseServerErrorCode.ServerConnectionFailure) {
                    _this.customEvent.emit({
                        type: 5 /* Failed */,
                        additionalData: {
                            tenantId: tenantId,
                        },
                    });
                }
            });
        }, function () { }, this._translateService.instant('tenant_license_confirm_remove_license'));
    };
    TenantLicenseModalComponent.prototype.getUsedLicenses = function (used, allowed, filled) {
        var input = parseInt(filled, 10) || 0;
        return used - allowed + input;
    };
    TenantLicenseModalComponent.prototype.positiveClamp = function (number) {
        return number < 0 ?
            0 :
            number;
    };
    TenantLicenseModalComponent.prototype._updateFormValidators = function (tenantLicense) {
        var controlKeys = Object.keys(this.formGroup.controls);
        for (var _i = 0, controlKeys_1 = controlKeys; _i < controlKeys_1.length; _i++) {
            var controlKey = controlKeys_1[_i];
            var control = this.formGroup.get(controlKey);
            var allowed = this._appState.user.license.value.allowed[controlKey];
            var used = this._appState.user.license.value.used[controlKey];
            var max = allowed - used;
            var assignedAlready = tenantLicense.allowed[controlKey];
            control.setValidators(UiValidators.range(0, max + assignedAlready));
        }
    };
    TenantLicenseModalComponent.prototype._updateReadState = function () {
        if (this.isSelfLicensed) {
            this.formGroup.disable();
        }
        else {
            this.formGroup.enable();
        }
    };
    return TenantLicenseModalComponent;
}(UiModalComponent));
export { TenantLicenseModalComponent };
